import React from 'react';

import {ListGroupItem, Button, ListGroup, Heading, Text} from '@albert-io/atomic';

import {AuthorDashboardConsumer} from '../AuthorDashboardProvider/AuthorDashboardConsumer.react';

import AuthorFeedbackItem from './AuthorFeedbackItem.react';
import AuthorPublishedQuestionItem from './AuthorPublishedQuestionItem.react';

import './author-dashboard-activity.scss';

const renderActivity = (
  isNewAuthor,
  activityItems,
  noActivity,
  indexOfActivity,
  handleShowMore
) => {
  if (noActivity) {
    return (
      <div>
        <Heading size='m' className='author-dashboard-activity__header u-mar-b_3'>
          Activity
        </Heading>
        <Text>You have no recent activity</Text>
      </div>
    );
  }
  if (activityItems && !noActivity) {
    return (
      <div>
        <Heading size='m' className='author-dashboard-activity__header u-mar-b_3'>
          Activity
        </Heading>
        <ListGroup>
          {activityItems.map((item, idx) => {
            if (idx < indexOfActivity && item.type === 'feedback') {
              return (
                <ListGroupItem key={idx} paddingLevel={3}>
                  <AuthorFeedbackItem feedback={item} />
                </ListGroupItem>
              );
            }
            if (idx < indexOfActivity && item.type === 'publishedQuestion') {
              return (
                <ListGroupItem key={idx} paddingLevel={3}>
                  <AuthorPublishedQuestionItem publishedQuestion={item} />
                </ListGroupItem>
              );
            }
          })}
        </ListGroup>
        {indexOfActivity <= activityItems.length && (
          <Button
            as='button'
            className='author-dashboard-activity__button'
            onClick={handleShowMore}
            variant='text'
          >
            Show more
          </Button>
        )}
      </div>
    );
  }
  return null;
};

const AuthorDashboardActivity = () => {
  return (
    <div>
      <AuthorDashboardConsumer field='activityItems'>
        {({activityItems, indexOfActivity, handleShowMore, noActivity, isNewAuthor}) => {
          return renderActivity(
            isNewAuthor,
            activityItems,
            noActivity,
            indexOfActivity,
            handleShowMore
          );
        }}
      </AuthorDashboardConsumer>
    </div>
  );
};

export default AuthorDashboardActivity;
